var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSeven(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "24px",
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Seven") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NGS_Payment_PayInCash",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02_Payment_PayinCash",
    transform: "translate(-500.000000, -1913.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Payment",
    transform: "translate(165.000000, 1479.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 66.000000)",
    id: "Select-your-country_B"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(285.000000, 130.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Debit",
    transform: "translate(20.000000, 164.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Seven",
    transform: "translate(6.000000, 70.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Path",
    x: 0,
    y: 0,
    width: 72,
    height: 32
  }), /*#__PURE__*/React.createElement("g", {
    id: "7-eleven-brand",
    transform: "translate(24.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "polygon10",
    fill: "#FFFFFF",
    points: "0.124556315 0.248041697 24.5265428 0.248041697 24.5265428 23.8796604 0.124556315 23.8796604"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon12",
    fill: "#008061",
    points: "-0.00024266984 0.0664328371 24.6297926 0.0664328371 24.6297926 23.9982324 -0.00024266984 23.9982324"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1856716,22.4236251 L15.1856716,23.3817573 L9.27824336,23.3817573 L9.27824336,22.4218367 L4.80807666,22.4218367 C4.37129182,22.4218367 4.01550356,21.9653216 4.01550356,21.4024201 L2.145015,2.48500359 C2.145015,1.92176062 2.58179984,1.46487341 3.12077834,1.46487341 L21.184639,1.46487341 C21.7201066,1.46487341 22.1568888,1.92176243 22.1568888,2.48500359 L20.3075268,21.4024201 C20.3075268,21.965318 19.9517241,22.4218367 19.5149537,22.4218367 L15.1856644,22.4236251 L15.1856716,22.4236251 Z",
    id: "path14",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.43512596,4.23466659 L17.5282533,4.23466659 C16.3375836,4.68099228 12.7128436,7.13517574 11.8075596,8.78521205 L5.44573254,8.78521205 L5.43512596,4.23466659 L5.43512596,4.23466659 Z",
    id: "path16",
    fill: "#F5821F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0730384,17.2735673 C14.9004259,18.921472 14.8933744,20.9282676 14.8933744,23.0361982 L9.65174675,23.0361982 C9.65174675,20.9282676 9.73982287,18.921472 9.91239289,17.2735673 L15.0730384,17.2735673 L15.0730384,17.2735673 Z",
    id: "path18",
    fill: "#ED1B2D"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon20",
    fill: "#008061",
    points: "6.96397803 14.8922821 6.96397803 15.5309586 6.12560556 15.5309586 6.12560556 16.1699061 6.96397803 16.1699061 6.96397803 16.901977 5.04765036 16.901977 5.04765036 13.4952505 6.96397803 13.4952505 6.96397803 14.2540571 6.12560556 14.2540571 6.12560556 14.8922821"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon22",
    fill: "#008061",
    points: "11.4200001 14.8922821 11.4200001 15.5309586 10.5852315 15.5309586 10.5852315 16.1699061 11.4200001 16.1699061 11.4200001 16.901977 9.50731246 16.901977 9.50731246 13.4952505 11.4200001 13.4952505 11.4200001 14.2540571 10.5852315 14.2540571 10.5852315 14.8922821"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon24",
    fill: "#008061",
    points: "16.3305203 14.8922821 16.3305203 15.5309586 15.4921388 15.5309586 15.4921388 16.1699061 16.3305203 16.1699061 16.3305203 16.901977 14.4142197 16.901977 14.4142197 13.4952505 16.3305203 13.4952505 16.3305203 14.2540571 15.4921388 14.2540571 15.4921388 14.8922821"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon26",
    fill: "#008061",
    points: "8.40121249 13.4952505 8.40121249 16.1699061 9.23950367 16.1699061 9.23950367 16.901977 7.32327535 16.901977 7.32327535 13.4952505"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon28",
    fill: "#008061",
    points: "12.9665168 15.7976835 12.5578036 13.4952505 11.6173567 13.4952505 12.1527033 16.901977 13.5370895 16.901977 14.18525 13.4952505 13.3856172 13.4952505"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon30",
    fill: "#008061",
    points: "16.7849372 13.4952505 17.8206752 13.4952505 17.8206752 16.9016157 16.7849372 16.9016157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8205849,14.5066013 C17.8769855,14.1335432 18.4053583,14.233607 18.4053583,14.4466889 L18.4053583,16.901949 L19.4445196,16.901949 L19.4445196,14.0144825 C19.4445196,13.40225 18.5814708,13.1560104 17.827641,13.6949898 L17.8205849,14.5066031 L17.8205849,14.5066013 Z",
    id: "path32",
    fill: "#008061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5591588,13.0161754 C15.6648073,11.7124389 17.4507559,9.58339966 19.180349,9.0243522 L19.180349,3.99474062 C14.4213463,6.12384305 11.3284664,9.34386209 10.6592064,13.0034759 L15.5591497,13.0161754 L15.5591588,13.0161754 Z",
    id: "path34",
    fill: "#ED1B2D"
  })))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeven);
export default __webpack_public_path__ + "static/media/seven.eeed428e0014b6a049b50498ac98d9b8.svg";
export { ForwardRef as ReactComponent };